var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1924 25.6619H37.8744C37.7647 21.7824 36.9527 18.018 35.4975 14.5293C32.8118 15.3091 30.0271 15.7383 27.1924 15.8141V25.6619Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4797 12.3425C39.0923 11.4413 41.5932 10.2082 43.9104 8.62268L44.4931 8.17655C40.2308 3.9562 34.5132 1.20985 28.1702 0.753906L27.708 1.12954C31.468 4.24261 34.4409 8.06948 36.4797 12.3425Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1924 3.03711V14.0297C29.7719 13.9565 32.3059 13.5719 34.7524 12.8849C32.9438 9.17313 30.3884 5.8254 27.1924 3.03711Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5039 38.347C40.2967 39.357 42.9645 40.7275 45.4316 42.4862L46.206 43.0661C49.7536 38.7967 51.9513 33.3709 52.1529 27.4473H39.6596C39.5588 31.2286 38.82 34.9038 37.5039 38.347Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68923 8.62268C11.0064 10.2082 13.5083 11.4404 16.1199 12.3425C18.1587 8.07037 21.1317 4.2435 24.8925 1.12954L24.4303 0.753906C18.073 1.21074 12.343 3.96869 8.07715 8.20421L8.68923 8.62268Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4077 3.03711C22.2108 5.8254 19.6563 9.17402 17.8477 12.884C20.2942 13.571 22.8282 13.9565 25.4077 14.0288V3.03711Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9415 27.4473H0.447266C0.649807 33.3709 2.84653 38.7958 6.39413 43.0661L7.15254 42.4996C9.62854 40.7356 12.3017 39.3606 15.0989 38.3488C13.7802 34.9029 13.0423 31.2277 12.9415 27.4473Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3943 13.9785C12.6845 13.0291 10.0898 11.7434 7.68165 10.0963L6.84471 9.52344C3.03569 13.8696 0.657837 19.4944 0.447266 25.6625H12.9415C13.0494 21.5938 13.8855 17.6429 15.3943 13.9785Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7266 25.6621H25.4086V15.8143C22.5721 15.7385 19.7865 15.3093 17.1026 14.5312C15.6474 18.0191 14.8354 21.7826 14.7266 25.6621Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8032 51.8996C20.8603 48.6028 17.807 44.5305 15.7816 39.9961C13.112 40.9544 10.561 42.2606 8.20461 43.9399L7.58984 44.3994C11.8495 48.8633 17.6812 51.8086 24.1902 52.3368L24.8032 51.8996Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4086 36.4037V27.4473H14.7266C14.8274 31.0332 15.5341 34.5175 16.7903 37.7795C19.5679 36.9426 22.4588 36.4822 25.4086 36.4037Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3787 43.9274C42.0311 42.2544 39.4873 40.9517 36.8222 39.9961C34.795 44.5412 31.7381 48.617 27.7988 51.9023L28.41 52.3368C34.919 51.8086 40.7517 48.8642 45.0113 44.4003L44.3787 43.9274Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9569 10.0668C42.53 11.7282 39.9219 13.0211 37.2041 13.9749C38.7138 17.6403 39.5498 21.5921 39.6587 25.6616H52.1529C51.9414 19.4739 49.5502 13.8339 45.7206 9.48242L44.9569 10.0668Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4084 50.0714V38.1875C22.6968 38.2633 20.0406 38.6836 17.4834 39.4367C19.3063 43.4598 21.9875 47.0877 25.4084 50.0714Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8744 27.4473H27.1924V36.4037C30.1431 36.4822 33.0349 36.9426 35.8133 37.7795C37.066 34.5184 37.7727 31.0341 37.8744 27.4473Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.12 39.4367C32.5628 38.6836 29.9048 38.2642 27.1924 38.1875V50.075C30.6106 47.1011 33.2945 43.4696 35.12 39.4367Z",
    fill: "#4afc2d",
    fillOpacity: 0.79
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.6c4be74de6b6bc21bdf62030d1ab0f27.svg";
export { ForwardRef as ReactComponent };